import React, { useEffect, useState, useRef } from 'react';
import ReactQuill from 'react-quill';
// import { Editor } from "@tinymce/tinymce-react";

const MessageBox = ({ message_area, hght, divCls, onMessageChange, value }) => {

    const quillRef = useRef(null);    
    const editorRef = useRef(null);
    const [editorData, setEditorData] = useState('');

    const modules = {
        // toolbar: {
        //   container: [
        //     ['bold', 'italic', 'underline'], // Text formatting options
        //     [{ 'list': 'ordered'}, { 'list': 'bullet' }], // Lists
        //     ['image'] // Add image button
        //   ],
        //   handlers: {
        //     image: handleImageUpload // Custom handler for image uploads
        //   }
        // }
        toolbar: [
            [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['bold', 'italic', 'underline'],
            ['link'],
            [{ 'align': [] }],
            // ['image'], // Add the image option to the toolbar
        ],
    };

    const toolbarOptions = `
    undo redo | table | print preview | formatselect | bold italic underline  | 
    fontselect fontsizeselect formatselect |
    alignleft aligncenter alignright alignjustify | 
    bullist numlist outdent indent | forecolor backcolor removeformat |
    image  link |  fullscreen 
  `;
    const pluginList = `
    print preview importcss searchreplace autolink autosave save directionality code
    visualblocks visualchars fullscreen image link media template codesample table
    charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount
    imagetools textpattern noneditable help charmap quickbars emoticons
  `;

  const fontFormats = `
  Arial=arial,helvetica,sans-serif;
  Verdana=verdana,geneva;
  Times New Roman=times new roman,times;
  Courier New=courier new,courier;
  Georgia=georgia,palatino;
  Tahoma=tahoma,arial,helvetica,sans-serif;
  Trebuchet MS=trebuchet ms,geneva;
  Impact=impact,chicago;
  Comic Sans MS=comic sans ms,sans-serif
`;

    useEffect(() => {
        if (value) {
            setEditorData(value || "")
        }
    }, [value])

    const handleEditorChange = (value) => {
        setEditorData(value);
        if (onMessageChange) {
            onMessageChange(value);
        }
    };

    return (
        <div className={`${divCls ?? 'mt-3'}`}>
            <ReactQuill
                ref={quillRef}
                value={editorData}
                onChange={handleEditorChange}
                modules={modules}
                formats={['bold', 'italic', 'underline', 'list', 'image']}
                placeholder="Write something..."
                className='textedtor'
                style={{ height: `${hght ? hght : ''}` }}
            />

            {/* <Editor
                apiKey="nz8v8sfwvtijo5nnkjq55z1i4q6ii67wp9x1dv4v9069fj66" // Get from https://www.tiny.cloud
                value={editorData}
                onInit={(_evt, editor) => editorRef.current = editor}
                init={{
                    height: 500,
                    menubar: false,
                    plugins: pluginList,
                    toolbar: toolbarOptions,
                    font_formats: fontFormats,
                    fontsize_formats: "8pt 9pt 10pt 11pt 12pt 14pt 18pt 24pt 36pt",
                    image_advtab: true,
                    image_uploadtab: true,
                    file_picker_types: "image",
                    images_upload_handler: (blobInfo, success, failure) => {
                        const reader = new FileReader();
                        reader.readAsDataURL(blobInfo.blob());
                        reader.onloadend = () => success(reader.result);
                    },
                    branding: false,
                    content_style:
                        "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                }}
                onEditorChange={handleEditorChange}
            /> */}
        </div>
    )
}

export default MessageBox;